import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts";
import Breadcrumb from "../components/UI/breadcrumb";
import styles from "../containers/contact-faqs/contact-faq-one/ContactFaqOne.module.scss";
import { Link } from "react-router-dom";
import Button from "../components/UI/button";

const About = () => {
    return (
        <Fragment>
            <MetaTags>
                <title>Adaptive Systems LLC | Do Not Sell My Info</title>
                <meta
                    name="description"
                    content=""
                />
            </MetaTags>
            <LayoutOne>
                <Breadcrumb title="Do Not Sell My Info" />
                <div className="container pt--60 pb--60">
                    <h4>Effective Date: 07 July 2025</h4>

                    <p>Adaptive Systems LLC respects your privacy and is committed to protecting your personal information. Under the California Consumer Privacy Act (CCPA), California residents have the right to request that we do not sell or share their personal information.</p>

                    <h4>Your Rights Under CCPA</h4>
                    <p>As a California resident, you have the right to:</p>
                    <ul>
                        <li>Opt out of the sale or sharing of your personal information</li>
                        <li>Request access to the personal information we collect, use, or disclose about you</li>
                        <li>Request deletion of your personal information, subject to certain exceptions</li>
                        <li>Correct inaccurate information we hold about you</li>
                        <li>Non-discrimination for exercising your privacy rights</li>
                    </ul>

                    <h4>How We Use Personal Information</h4>
                    <p>We may collect limited personal information such as:</p>
                    <ul>
                        <li>Name, email, phone number, and ZIP code (when you submit forms on our site)</li>
                        <li>Internet activity data (cookies, analytics) for website functionality and ad performance</li>
                    </ul>

                    <p>We do not sell your personal information in exchange for money. However, we may share information with trusted partners and providers to deliver services and offers.</p>

                    <h4>How to Exercise Your Rights</h4>

                    <p>To submit a request under CCPA, you may:</p>

                    <ul>
                        <li>Call us: +1 (877) 514-5141</li>
                        <li>Email us: info@adaptivesystems-llc.com</li>
                        <li><a href="#form">Complete our request form</a></li>
                    </ul>

                    <p>When you submit a request, we will verify your identity before processing.</p>

                    <h4>Authorized Agents</h4>
                    <p>You may designate an authorized agent to make a request on your behalf. We will require proof of identity and signed authorization.</p>

                    <h4>Contact Us</h4>

                    <p>If you have questions about this notice or our privacy practices, contact us at:</p>

                    <h4> Adaptive Systems LLC</h4>
                    <p>Email: info@adaptivesystems-llc.com</p>
                    <p> Phone: +1 (877) 514-5141</p>

                </div>









                <div className="voopo__faq__area pb--120 bg--white" id="form">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-6 sm__mt--40 xs__mt--40">
                                <div className={styles.faqInner} style={{paddingLeft:'0'}}>
                                    <div className={styles.content}>
                                        <h2>Submit a Privacy Request</h2>
                                        <p>
                                            California residents may use this form to request access, deletion, correction, or opt out of the sale/sharing of personal information under the CCPA.
                                        </p>
                                        <div className={styles.inputBox}>
                                            <input type="text" placeholder="Full Name" required/>
                                            <input type="email" placeholder="Email" required/>
                                            <input type="text" placeholder="Phone" />
                                            <input type="text" placeholder="ZIP" maxLength={5} />
                                            <select>
                                                <option>Request Type</option>
                                                <option>Access my personal information</option>
                                                <option>Delete my personal information</option>
                                                <option>Correct inaccurate information</option>
                                                <option>Do not sell or share my personal information</option>
                                            </select>
                                            <div className={styles.checkBoxDiv}>
                                                <input type="checkbox" id="check" name="check" className={styles.checkBox} required />
                                                <label for="check">I declare under penalty of perjury that I am the consumer whose personal information is the subject of this request, or an authorized agent.</label>
                                            </div>
                                            <div className={styles.qusBtn}>
                                                <Button type="button" text="Submit Request" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </LayoutOne>
        </Fragment>
    );
};

export default About;
